export default "__VITE_ASSET__DW1A2oio__"